import { vnTemplate } from "@valnet/vnKnockoutJsTemplates/vnTemplate";
import { filterDate_template } from "~/components/templates/filterDate_template";
import { multipleSelector_template } from "@valnet/vnKnockoutJsTemplates/multipleSelector_template";
import { presetFilter_template } from "@valnet/vnKnockoutJsTemplates/presetFilter_template";
import { html, LpButton, LpIcon, LpPageHeader, raw } from "~/design-system";
import { createCopyLinkAction } from "~/utils/clipboard";
import { setOptionalIconName } from "~/utils/iconName";
const relativeTimeFormatter = new Intl.RelativeTimeFormat(undefined, {
    numeric: "auto",
});
function parseLastRefreshedAt(value) {
    if (!value) {
        return null;
    }
    const normalizedValue = value.includes("T") ? value : value.replace(" ", "T");
    const date = new Date(normalizedValue);
    return Number.isNaN(date.getTime()) ? null : date;
}
function formatLastRefreshedDateTime(date) {
    return date.toLocaleString(undefined, {
        dateStyle: "medium",
        timeStyle: "short",
    });
}
export class auctionResultDistribution_template extends vnTemplate {
    getTemplateHtml() {
        return /* html */ `
            ${LpPageHeader({
            title: "Auction Result Distribution",
            description: "Review how auction result counts are distributed across result pages, thank-you pages, devices, and traffic sources.",
            icon: "chart-pie-slice",
            actions: LpButton({
                label: html `<span data-bind="text: copyLinkLabel"></span>`,
                prefixIcon: "link",
                size: "base",
                variant: "secondary",
                attributes: {
                    "data-bind": "click: onCopyLink",
                },
            }),
            controls: html `
                    <div class="insights-header-controls auction-result-distribution-header-controls" data-bind="css: { 'is-open': showMoreFilters }">
                        <div
                            class="insights-filters-backdrop"
                            data-bind="click: closeMoreFilters, visible: showMoreFilters"
                        ></div>
                        <div class="insights-header-primary">
                            <div class="hidden">
                                ${raw(this.presetFilter.getHtmlBuild())}
                            </div>
                            <div class="auction-insights-filter-cell">
                                <div class="lib-date-picker">
                                    ${raw(this.datesFilter.getHtmlBuild())}
                                </div>
                            </div>
                            <div class="insights-filters-sheet insights-responsive-filter-sheet">
                                <div class="auction-insights-filter-cell insights-responsive-inline-filter">
                                    ${raw(this.productFilter.getHtmlBuild())}
                                </div>
                                <div class="auction-insights-filter-cell insights-responsive-inline-filter">
                                    ${raw(this.trafficFilter.getHtmlBuild())}
                                </div>
                                <div class="auction-insights-filter-cell insights-responsive-inline-filter">
                                    ${raw(this.channelFilter.getHtmlBuild())}
                                </div>
                                <div class="insights-filters-secondary insights-global-filters">
                                    <header class="insights-global-filters__header">
                                        <h2 class="insights-global-filters__title">Advanced Filters</h2>
                                        ${LpButton({
                ariaLabel: "Close filters",
                prefixIcon: "x",
                size: "sm",
                shape: "square",
                variant: "ghost",
                className: "insights-global-filters__icon-btn",
                attributes: {
                    "data-bind": "click: closeMoreFilters",
                },
            })}
                                    </header>
                                    <div class="insights-global-filters__list insights-advanced-filter-groups">
                                        ${raw(this.getDisplayFiltersHtml())}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="insights-header-actions">
                            ${raw(this.getHeaderActionsHtml())}
                        </div>
                    </div>
                `,
        })}

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="auction-result-distribution-selected-brands"></div>
                    <div id="auction-result-distribution-selected-products"></div>
                    <div id="auction-result-distribution-selected-traffics"></div>
                    <div id="auction-result-distribution-selected-channels"></div>
                    <div id="auction-result-distribution-selected-devices"></div>
                    <div id="auction-result-distribution-selected-form-variants"></div>
                    <div id="auction-result-distribution-selected-audiences"></div>
                    <div id="auction-result-distribution-selected-click-auction-experiments"></div>
                    <div id="auction-result-distribution-selected-lead-auction-experiments"></div>
                </div>
            </div>

            <div class="module-grid">
                <div class="data-module">
                    <header class="data-module__header">
                        <div class="data-module__label">
                            <span class="lp-data-table_layer-title-content">
                                ${LpIcon({ name: "chart-pie-slice", size: 16, className: "lp-data-table_layer-title-icon" })}
                                <span>Daily Result Distribution</span>
                                <span
                                    class="lp-badge"
                                    data-variant="primary"
                                    data-bind="visible: lastRefreshedLabel, text: lastRefreshedLabel"
                                ></span>
                            </span>
                        </div>
                    </header>
                    <div class="data-module__body" id="list-results">
                        <div class="table-scroll">
                            <div class="table-scroll__wrapper">
                                <table class="tbl" data-reverse-rows>
                                    <thead>
                                        <tr>
                                            <th class="tbl-h"><div class="tbl-h-inner"><span class="tbl-h-content">Date</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">Results Auctions</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">Results 0</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">Results 1</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">Results 2</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">Results 3</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">Results 3+</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">TY Auctions</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">TY 0</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">TY 1</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">TY 2</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">TY 3</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">TY 3+</span></div></th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="foreach: listData">
                                        <tr class="tbl-r">
                                            <td class="tbl-c"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: dateData"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatNumeric(resultsPageAuctionCount)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(resultsPage0ResultsPct)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(resultsPage1ResultPct)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(resultsPage2ResultsPct)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(resultsPage3ResultsPct)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(resultsPage3PlusResultsPct)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatNumeric(thankYouPageAuctionCount)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(thankYouPage0ResultsPct)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(thankYouPage1ResultPct)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(thankYouPage2ResultsPct)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(thankYouPage3ResultsPct)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(thankYouPage3PlusResultsPct)"></span></div></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    getDisplayFiltersHtml() {
        return [
            {
                title: "General",
                filters: [
                    this.brandFilter.getHtmlBuild(),
                    this.deviceFilter.getHtmlBuild(),
                    this.formVariantFilter.getHtmlBuild(),
                    this.audienceFilter.getHtmlBuild(),
                ],
            },
            {
                title: "Auction Experiments",
                filters: [
                    this.clickAuctionExperimentFilter.getHtmlBuild(),
                    this.leadAuctionExperimentFilter.getHtmlBuild(),
                ],
            },
        ].map(({ title, filters }) => (this.getAdvancedFilterGroup(title, filters))).join("");
    }
    getHeaderActionsHtml() {
        return String(html `
            ${LpButton({
            label: "Filters",
            prefixIcon: "funnel",
            size: "base",
            variant: "ghost",
            attributes: {
                "data-bind": "click: toggleMoreFilters, attr: { 'aria-expanded': showMoreFilters() ? 'true' : 'false' }",
            },
        })}
            ${LpButton({
            label: "Reset",
            prefixIcon: "arrows-clockwise",
            variant: "primary",
            attributes: {
                "data-bind": "click: resetFilters",
            },
        })}
        `);
    }
    getAdvancedFilterGroup(title, filters) {
        return /* html */ `
            <section class="insights-advanced-filter-group">
                <h3 class="insights-advanced-filter-group__title">${title}</h3>
                <div class="insights-advanced-filter-group__list">
                    ${filters.map((bodyHtml) => this.getAdvancedFilterControl(bodyHtml)).join("")}
                </div>
            </section>
        `;
    }
    getAdvancedFilterControl(bodyHtml) {
        return /* html */ `
            <div class="insights-advanced-filter">
                ${bodyHtml}
            </div>
        `;
    }
    initPartial() {
        const vm = this.getTemplateViewModel();
        this.presetFilter = new presetFilter_template("presetFilter", vm, this.caller);
        this.presetFilter.setType("auction_result_distribution");
        this.brandFilter = this.buildMultiSelector("brandFilter", "brands", "auction-result-distribution-selected-brands", "Selected brands:", "tag");
        this.productFilter = this.buildMultiSelector("productFilter", "products", "auction-result-distribution-selected-products", "Selected products:", "package");
        this.trafficFilter = this.buildMultiSelector("trafficFilter", "traffic source", "auction-result-distribution-selected-traffics", "Selected traffic sources:", "traffic-signal");
        this.channelFilter = this.buildMultiSelector("channelFilter", "distribution channel", "auction-result-distribution-selected-channels", "Selected channels:", "broadcast");
        this.deviceFilter = this.buildMultiSelector("deviceFilter", "device", "auction-result-distribution-selected-devices", "Selected devices:", "device-mobile");
        this.formVariantFilter = this.buildMultiSelector("formVariantFilter", "form variant", "auction-result-distribution-selected-form-variants", "Selected form variants:", "clipboard-text");
        this.audienceFilter = this.buildMultiSelector("audienceFilter", "audience", "auction-result-distribution-selected-audiences", "Selected audiences:", "user-list");
        this.clickAuctionExperimentFilter = this.buildMultiSelector("clickAuctionExperimentFilter", "click auction experiment", "auction-result-distribution-selected-click-auction-experiments", "Selected click auction experiments:", "flask");
        this.leadAuctionExperimentFilter = this.buildMultiSelector("leadAuctionExperimentFilter", "lead auction experiment", "auction-result-distribution-selected-lead-auction-experiments", "Selected lead auction experiments:", "flask");
        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);
        this.datesFilter.setStartPickerId("auction-result-distribution-start-date-picker");
        this.datesFilter.setEndPickerId("auction-result-distribution-end-date-picker");
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        let firstOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        if (date.getTime() === firstOfMonth.getTime()) {
            firstOfMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        }
        this.datesFilter.setDateRange(firstOfMonth, date);
    }
    getTemplateName() {
        return "auctionResultDistribution_template";
    }
    getMainElementClasses() {
        return ["w-content", "auction-result-distribution-page"];
    }
    buildViewModel() {
        const self = this;
        const { copyLinkLabel, onCopyLink } = createCopyLinkAction(ko);
        return {
            copyLinkLabel,
            onCopyLink,
            isLoading: ko.observable(0),
            lastRefreshedLabel: ko.observable(""),
            listData: ko.observableArray([]),
            showMoreFilters: ko.observable(false),
            resetFilters: function () {
                self.resetFilters();
            },
            toggleMoreFilters: function () {
                const vm = self.getTemplateViewModel();
                const next = !vm.showMoreFilters();
                vm.showMoreFilters(next);
            },
            closeMoreFilters: function () {
                self.getTemplateViewModel().showMoreFilters(false);
            },
            formatNumeric: function (value, digits) {
                return self.formatNumeric(value, digits);
            },
            formatPercent: function (value, digits) {
                return self.formatPercent(value, digits);
            },
        };
    }
    getViewModelForRequest() {
        return {
            filters: {
                selectedBrands: this.brandFilter
                    .getSelectedItems()
                    .map((itemId) => ({ id: itemId })),
                selectedProducts: this.productFilter.getSelectedItems(),
                selectedTraffics: this.trafficFilter.getSelectedItems(),
                selectedChannels: this.channelFilter.getSelectedItems(),
                selectedDevices: this.deviceFilter.getSelectedItems(),
                selectedFormVariants: this.formVariantFilter.getSelectedItems(),
                selectedAudiences: this.audienceFilter.getSelectedItems(),
                selectedClickAuctionExperiments: this.clickAuctionExperimentFilter.getSelectedItems(),
                selectedLeadAuctionExperiments: this.leadAuctionExperimentFilter.getSelectedItems(),
                dateFilterType: this.datesFilter.getTemplateViewModel().selectedFilter(),
                startDate: this.datesFilter.getTemplateViewModel().startDate(),
                endDate: this.datesFilter.getTemplateViewModel().endDate(),
                startDateRange: this.datesFilter.getTemplateViewModel().fromRange(),
                endDateRange: this.datesFilter.getTemplateViewModel().toRange(),
            },
        };
    }
    activateLoading() {
        this.getTemplateViewModel().isLoading(1);
    }
    deactivateLoading() {
        this.getTemplateViewModel().isLoading(0);
    }
    buildDatePickerCalendar() {
        this.datesFilter.buildCalendarWhenReady();
    }
    destroyDatePickerCalendar() {
        this.datesFilter.destroyCalendars();
    }
    setBrandFilterItems(items) {
        this.setMultiSelectItems(this.brandFilter, items || []);
    }
    setProductFilterItems(items) {
        this.setMultiSelectItems(this.productFilter, items || []);
    }
    setTrafficFilterItems(items) {
        this.setMultiSelectItems(this.trafficFilter, items || []);
    }
    setChannelFilterItems(items) {
        this.setMultiSelectItems(this.channelFilter, items || []);
    }
    setDeviceFilterItems(items) {
        this.setMultiSelectItems(this.deviceFilter, items || []);
    }
    setFormVariantFilterItems(items) {
        this.setMultiSelectItems(this.formVariantFilter, items || []);
    }
    setAudienceFilterItems(items) {
        this.setMultiSelectItems(this.audienceFilter, items || []);
    }
    setClickAuctionExperimentFilterItems(items) {
        this.setMultiSelectItems(this.clickAuctionExperimentFilter, items || []);
    }
    setLeadAuctionExperimentFilterItems(items) {
        this.setMultiSelectItems(this.leadAuctionExperimentFilter, items || []);
    }
    setListData(data) {
        this.getTemplateViewModel().listData(data || []);
    }
    setStatus(status) {
        const maxDateCreated = status?.maxDateCreated ?? null;
        const label = this.formatLastRefreshedLabel(maxDateCreated);
        this.getTemplateViewModel().lastRefreshedLabel(label);
    }
    setViewModelFromRequest(params) {
        let selectedBrands = params["selectedBrands"];
        if (typeof selectedBrands !== "undefined" && !Array.isArray(selectedBrands)) {
            selectedBrands = [selectedBrands];
        }
        if (Array.isArray(selectedBrands)) {
            const normalizedSelectedBrands = selectedBrands.map((item) => {
                if (typeof item === "object" &&
                    item !== null &&
                    typeof item["id"] !== "undefined") {
                    return item["id"];
                }
                return item;
            });
            this.presetFilter.setMultiSelectorPresetFilters(this.brandFilter, normalizedSelectedBrands);
        }
        this.presetFilter.setMultiSelectorPresetFilters(this.productFilter, params["selectedProducts"]);
        this.presetFilter.setMultiSelectorPresetFilters(this.trafficFilter, params["selectedTraffics"]);
        this.presetFilter.setMultiSelectorPresetFilters(this.channelFilter, params["selectedChannels"]);
        this.presetFilter.setMultiSelectorPresetFilters(this.deviceFilter, params["selectedDevices"]);
        this.presetFilter.setMultiSelectorPresetFilters(this.formVariantFilter, params["selectedFormVariants"]);
        this.presetFilter.setMultiSelectorPresetFilters(this.audienceFilter, params["selectedAudiences"]);
        this.presetFilter.setMultiSelectorPresetFilters(this.clickAuctionExperimentFilter, params["selectedClickAuctionExperiments"]);
        this.presetFilter.setMultiSelectorPresetFilters(this.leadAuctionExperimentFilter, params["selectedLeadAuctionExperiments"]);
        this.presetFilter.setDates(this.datesFilter, params["dateFilterType"], params["startDate"], params["endDate"], params["startDateRange"], params["endDateRange"]);
    }
    formatNumeric(value, digits = 0) {
        let n = Number(value);
        if (isNaN(n)) {
            n = 0;
        }
        return n.toLocaleString("en-EG", {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        });
    }
    formatPercent(value, digits = 2) {
        return this.formatNumeric(value, digits) + "%";
    }
    resetFilters() {
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        let firstOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        if (date.getTime() === firstOfMonth.getTime()) {
            firstOfMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        }
        this.datesFilter.setDateRange(firstOfMonth, date);
        this.resetDisplayFilters(false);
        this.caller.getData();
    }
    resetDisplayFilters(reload = true) {
        this.clearMultiFilterTags(this.brandFilter);
        this.clearMultiFilterTags(this.productFilter);
        this.clearMultiFilterTags(this.trafficFilter);
        this.clearMultiFilterTags(this.channelFilter);
        this.clearMultiFilterTags(this.deviceFilter);
        this.clearMultiFilterTags(this.formVariantFilter);
        this.clearMultiFilterTags(this.audienceFilter);
        this.clearMultiFilterTags(this.clickAuctionExperimentFilter);
        this.clearMultiFilterTags(this.leadAuctionExperimentFilter);
        this.caller.getData();
    }
    clearMultiFilterTags(filter) {
        filter.setSeletedItemIds([]);
        const tvm = filter.getTemplateViewModel();
        tvm.openedGroupsDrawers([]);
        const el = filter.getTagContainer();
        if (el) {
            el.innerHTML = "";
        }
    }
    buildMultiSelector(id, label, tagContainerId, tagCaption, iconName) {
        const filter = new multipleSelector_template(id, this.getTemplateViewModel(), this.caller);
        filter.setLabel(label);
        setOptionalIconName(filter, iconName);
        filter.setFilterContainerClass("lib-dropdown");
        filter.setTagContainerId(tagContainerId);
        filter.setTagContainerCaption(tagCaption);
        return filter;
    }
    setMultiSelectItems(filter, items) {
        filter.setItems(items);
    }
    formatLastRefreshedLabel(value) {
        const date = parseLastRefreshedAt(value);
        if (!date) {
            return "";
        }
        const elapsed = Math.max(0, Date.now() - date.getTime());
        const minute = 60_000;
        const hour = 60 * minute;
        const day = 24 * hour;
        const dateTime = formatLastRefreshedDateTime(date);
        if (elapsed < minute) {
            return `Last refreshed just now · ${dateTime}`;
        }
        if (elapsed < hour) {
            return `Last refreshed ${relativeTimeFormatter.format(-Math.max(1, Math.floor(elapsed / minute)), "minute")} · ${dateTime}`;
        }
        if (elapsed < day) {
            return `Last refreshed ${relativeTimeFormatter.format(-Math.max(1, Math.floor(elapsed / hour)), "hour")} · ${dateTime}`;
        }
        return `Last refreshed ${relativeTimeFormatter.format(-Math.max(1, Math.round(elapsed / day)), "day")} · ${dateTime}`;
    }
}
